<div class="container">
  <div class="services-shell">
    <div class="section-header">
      <p class="eyebrow">Our Approach</p>
      <h2>We translate raw potential into industrial strength.</h2>
      <p>
      </p>
    </div>

    <div class="service-grid">
      <div class="service-card" *ngFor="let service of services; let i = index">
        <div class="service-icon" aria-hidden="true">{{ i + 1 < 10 ? '0' + (i + 1) : i + 1 }}</div>
        <div class="service-copy">
          <h3>{{ service.title }}</h3>
          <p>{{ service.description }}</p>
        </div>
      </div>
    </div>
  </div>
</div>
